import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { IconButton, Tooltip } from '@mui/material'
import { IHeaderParams } from 'ag-grid-community'
import { ReactElement } from 'react'

interface TooltipHeaderProps extends IHeaderParams {
  tooltipText?: string
}

const TooltipHeaderComponent = (props: TooltipHeaderProps): ReactElement => {
  const { displayName, tooltipText } = props

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
      {displayName}
      {tooltipText && (
        <Tooltip title={tooltipText} arrow placement="top">
          <IconButton size="small" sx={{ p: 0, ml: 0 }}>
            <InfoOutlinedIcon sx={{ fontSize: '1rem', color: 'action.active' }} />
          </IconButton>
        </Tooltip>
      )}
    </span>
  )
}

export default TooltipHeaderComponent
